import { createSelector } from '@ngrx/store';
import { selectOrganizationDataState } from '../index';

export const selectOrganizations = createSelector(selectOrganizationDataState, (state) => state.organizations);
export const selectLoadingStatus = createSelector(selectOrganizationDataState, (state) => state.orgLoadingStatus);
